import * as React from 'react'

import { F0Dialog } from '@factorialco/f0-react'
import { Cross } from '@factorialco/f0-react/icons/app'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

interface OneVideoModalProps {
  isOpen: boolean
  onClose: () => void
}

const OneVideoModal = ({ isOpen, onClose }: OneVideoModalProps) => {
  const { access } = useCurrentSession()

  if (!isOpen) return null

  const locale = access.locale

  const videoId = () => {
    switch (locale) {
      case 'en':
        return '9mUIcLa2te8'
      case 'es':
        return '7MhdfEPqqdE'
      case 'fr':
        return 'g1ryhgYOGnw'
      case 'de':
        return '6pOt7DL3tvY'
      case 'it':
        return 'Ac_-V-Kdfok'
      case 'it':
        return '9mUIcLa2te8'
      case 'pt':
        return 'sA2tEphgBPU'
      case 'pt-br':
        return 'sA2tEphgBPU'
      case 'es-mx':
        return '7MhdfEPqqdE'
      default:
        return '9mUIcLa2te8'
    }
  }

  return (
    <F0Dialog isOpen={isOpen} onClose={onClose} position="center">
      {/* Close Button - Inside modal but outside content */}
      <button
        onClick={onClose}
        className="absolute top-2 right-2 z-[9999] bg-white text-gray-800 hover:text-gray-600 hover:bg-gray-100 transition-colors rounded-full w-8 h-8 flex items-center justify-center shadow-lg border border-gray-300"
        aria-label="Close video"
        style={{ zIndex: 9999, backgroundColor: 'white', opacity: 1 }}
      >
        <Cross className="w-4 h-4" />
      </button>

      <div className="relative w-full max-w-4xl">
        {/* Video Container */}
        <div className="relative w-full aspect-video bg-black rounded-lg overflow-hidden">
          <iframe
            src={`https://www.youtube.com/embed/${videoId()}?autoplay=1&rel=0&controls=0`}
            title="One Video"
            className="w-full h-full"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </F0Dialog>
  )
}

export default OneVideoModal
